<template>
<v-dialog v-model="dialog" max-width="50%" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card tile>
        <v-card flat dark color="primary">
            <v-card-title class="title">
                Comment edit
            </v-card-title>
            <div style="position: relative; height: 3px">
                <v-progress-linear v-if="laoding_data" indeterminate height="3" class="pa-0 ma-0" color="orange" style="position: absolute" />
            </div>
        </v-card>
        <v-card-text>
            <v-row no-gutters>
                <v-col cols="12" class="pa-2">
                    <v-card class="elevation-1 pa-2">
                        <div class="detail font-weight-bold pa-0 ma-0">Resource ID *</div>
                        <v-text-field v-model="item.resource_id" class="im-select ma-0" solo flat clearable placeholder="Type here" hide-details />
                    </v-card>
                </v-col>

                <v-col cols="12" class="pa-2">
                    <v-card class="elevation-1 pa-2">
                        <div class="detail font-weight-bold pa-0 ma-0">Resource Type *</div>
                        <v-text-field v-model="item.resource_type" class="im-select ma-0" solo flat clearable placeholder="Type here" hide-details />
                    </v-card>
                </v-col>

                <v-col cols="12" class="pa-2">
                    <v-card class="elevation-1 pa-2">
                        <div class="detail font-weight-bold pa-0 ma-0">Resource Owner *</div>
                        <v-text-field v-model="item.resource_owner" class="im-select ma-0" solo flat clearable placeholder="Type here" hide-details />
                    </v-card>
                </v-col>

                <v-col cols="12" class="pa-2">
                    <v-card class="elevation-1 pa-2">
                        <div class="detail font-weight-bold pa-0 ma-0">Comment</div>
                        <tip-tap v-model="item.body" />
                    </v-card>
                </v-col>

                <!--<v-textarea v-model="comment.body" label="Content *" rows="20" box />-->
                <v-divider class="my-3"></v-divider>
                <v-col cols="12" class="px-1">
                    <v-card class="mb-3 elevation-1 pa-2">
                        <div class="detail font-weight-bold pa-0 ma-0">Status</div>
                        <v-select class="im-select pa-0 ma-0" flat solo v-model="item.status" :items="status_items" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" hide-details />
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="emitExit()">Cancel</v-btn>
            <v-btn color="primary" :loading="is_saving" @click="save()">Submit</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex'
import defaults from "../utils/PropDefaults.js"
import TipTap from "../utils/TipTap2.vue";
export default {
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        id: {
            type: [Number, String],
            default: null
        }
    },
    components: {
        'tip-tap': TipTap,
    },
    data() {
        return {
            laoding_data: false,
            is_saving: false,
            item: this.$clone(defaults.comment_item),
            status_items: [
                {
                    text: "Approved",
                    value: "approved"
                }, {
                    text: "Pending",
                    value: "pending"
                }, {
                    text: "Rejected",
                    value: "rejected"
                }
            ],
        }
    },
    watch: {
        id: {
            handler() {
                if(!!this.id) {
                    this.getItem();
                } else {
                    this.item = this.$clone(defaults.comment_item);
                }
            }
        },
        // dialog: {
        //     handler(newValue, oldValue) {
        //         if(newValue == false) {
        //             this.item = this.$clone(defaults.comment_item);
        //         }
        //     }
        // },
    },

    created() {
        if(!!this.id) {
            this.getItem();
        }
    },

    methods: {

        getItem() {
            this.laoding_data = true;
            if(!this.id) {
                return
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/comments/comments';

            this.$axios.get(endpoint + '/' + this.id) // eslint-disable-next-line
                .then(response => {
                    this.item = response.data;
                })
                .catch(error => {
                    console.error(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.laoding_data = false;
                });

        },

        save() {
            this.is_saving = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/comments/comments';

            // call update or save endpoints
            if(this.item.id) {

                this.$axios.put(endpoint + '/' + this.item.id, this.item) // eslint-disable-next-line
                    .then(response => {
                        this.getItems();
                        this.success('Comment updated.');
                        this.emitExit();
                        this.$emit('refresh');
                    })
                    .catch(error => {
                        console.error(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.is_saving = false;
                    });

            } else {

                this.$axios.post(endpoint, this.item) // eslint-disable-next-line
                    .then(response => {
                        this.success('Comment created.');
                        this.emitExit();
                        this.$emit('refresh');
                    })
                    .catch(error => {
                        console.log(error);
                        this.error('Oops, something went wrong!');
                    })
                    .finally(() => {
                        this.is_saving = false;
                    });

            }
        },

        emitClick() {
            this.$emit('click');
        },

        emitExit() {
            this.item = this.$clone(defaults.comment_item)
            this.$emit('exit');
        },
    },

}
</script>
